// extracted by mini-css-extract-plugin
export default {"main":"home-page_main__dciw4","shadow1":"home-page_shadow1__f+PE2"};